export class CommonService {

    public ward_ability = [
        'health care',
        'financial matters',
        'residence',
        'association',
        'others'
    ];

    public ward_inappropriate_alternatives = [
        'Durable Power of Attorney for Health Care',
        'Living Will',
        'Power of Attorney',
        'Durable Power of Attorney',
        'Trusts',
        'Joint Property Arrangements',
        'Representative Payee',
        'Money Management',
        'Single Court Transactions',
        'Government Benefits and Social Service Programs',
        'Housing Options',
        'Other'
    ];

    public guardian_disclaimer = [
        'No conflict of interest that would interfere with guardianship duties.',
        'No criminal background that would interfere with guardianship status.',
        'The capacity to manage financial resources involved.',
        'The ability to meet requirements of law and unique needs of individual.',
        'Demonstrated willingness to undergo training.'
    ];

    public pc23_clerk_comment_sections = [
        {
            'page1': [
                'firstName',
                'middleName',
                'lastName',
                'alias',
                'streetAddress',
                'city',
                'state',
                'zip',
                'dateOfBirth',
            ]
        },
        {
            'page2': [
                'assessor',
                'dateOfAssessment',
                'wardAbility'
            ]
        },
        {
            'page3': [
                'alternative',
            ]
        },
        {
            'page4': [
                'guardian',
                'guardianDisclaimer',
                'heir'
            ]
        }
    ];

    public getUnix(time: string) {
        let split = time.split('/');
        return split[0] + '/' + split[1] + '/' + split[2];
    }

    public cleanUnix(unix: number) {
        let date = new Date(unix);
        return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    }

    public formatTime(unix){
      let date = new Date(unix);
      return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    }

    public currentForm(name) {
      switch (name) {
        case 'TWOTHREE':
          return '2.3';
        case 'TWOFOUR':
          return '2.4';
        case 'THREEFOUR':
          return '3.4';
        case 'THREEFIVE':
          return '3.5';
        default:
          return name;
      }
    }

    public getLongForm(value){
      switch (value) {
        case '2.3':
          return 'TWOTHREE';
        case '2.4':
          return 'TWOFOUR';
        case '3.4':
          return 'THREEFOUR';
        case '2.8':
          return 'TWOEIGHT';
        case '7.1':
          return 'SEVENONE';
        case '3.5':
          return 'THREEFIVE';
        default:
          return value;
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/common.service.ts